import { render, staticRenderFns } from "./AdminEditLivreModal.vue?vue&type=template&id=37b15015"
import script from "./AdminEditLivreModal.vue?vue&type=script&lang=js"
export * from "./AdminEditLivreModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports